import React from 'react';
import { BaseForeignIdMapModal } from './BaseForeignIdMapModal';
import { useGetUnmappedFolders, useSetFolderForeignId } from '../../services/foreignService';
import { useQueryClient } from 'react-query';
import { useMessage } from '../../helpers/useMessages';
import { queryEnums } from '../../config/queryEnums';

interface FolderForeignIdMapModalProps {
    folderId: string;
    open: boolean;
    onClose: () => void;
}

export const FolderForeignIdMapModal: React.FC<FolderForeignIdMapModalProps> = ({
    folderId,
    open,
    onClose
}) => {
    const queryClient = useQueryClient();
    const { sendSuccess, sendError } = useMessage();
    const setForeignIdMutation = useSetFolderForeignId();

    const { data: candidates = [], isLoading, error } = useGetUnmappedFolders(open ? folderId : undefined);

    const handleSelect = (foreignId: string | number) => {
        setForeignIdMutation.mutate({ 
            folderId, 
            foreignId: foreignId as number 
        }, {
            onSuccess: () => {
                sendSuccess('Folder foreign ID set successfully');
                queryClient.invalidateQueries(queryEnums.foreign_unmapped_folders);
                queryClient.invalidateQueries(queryEnums.foreign_mapped_folders);
                onClose();
            },
            onError: (error: any) => {
                sendError(`Failed to set folder foreign ID: ${error.message}`);
            }
        });
    };

    return (
        <BaseForeignIdMapModal
            open={open}
            onClose={onClose}
            title="Map Folder to External System"
            candidates={candidates}
            isLoading={isLoading}
            error={error as Error}
            onSelect={handleSelect}
        />
    );
}; 